/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import CommandEnum from '../../command-enum';

/**
 * Komunikátor příkazů pro Ki-Wi Server.
 */
class CommunicatorCommand {
  /**
   * Zpracuje příkaz pro zařízení.
   * @param {string} [value] Příkaz pro zařízení ve formátu, který vrací server.
   * @returns {CommandEnum|null} Příkaz pro zařízení.
   */
  static parse(value) {
    let result;
    switch (value) {
      case 'info':
        result = CommandEnum.REPORT;
        break;
      case 'restart':
        result = CommandEnum.REBOOT;
        break;
      case 'shutdown':
        result = CommandEnum.POWER_OFF;
        break;
      default:
        result = null;
    }
    return result;
  }
}

export default CommunicatorCommand;
